"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shift = void 0;
class Shift {
    constructor(props) {
        this.active = props.active || true;
        this.frequency = props.frequency || 15;
        this.id = props.id || "";
        this.repeated = props.repeated || false;
        this.repeat = props.repeat || [];
        this.scheduleId = props.scheduleId || "";
        this.timestamps = props.timestamps || {};
        this.type = props.type || "online";
    }
}
exports.Shift = Shift;
